import { getAmplitudeInstance } from '../amplitudeHelpers';
import TrailDetailsSeeAllLocation from '../enums/TrailDetailsSeeAllLocation';
import TrailPageType from '../enums/TrailPageType';

type logTrailDetailsSeeAllClickedParams = {
  location?: TrailDetailsSeeAllLocation;
  trail_id: number;
  trail_page_type?: TrailPageType;
};

/**
 * User clicks the see all reviews button.
 * @param params - Attributes to log with the amplitude event
 * @param params.location - The location of the 'see all' on the trail details page.
 * @param params.trail_id - The trail id of the associated trail details page.
 * @param params.trail_page_type - Type of trail page where the CTA was clicked
 */
const logTrailDetailsSeeAllClicked = ({ location, trail_id, trail_page_type }: logTrailDetailsSeeAllClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('trail details see all clicked', { location, 'trail id': trail_id, 'trail page type': trail_page_type }, callback);
};

export default logTrailDetailsSeeAllClicked;
